import {useState, useMemo} from 'react';

function useToggle<T, U>(defaultValue: T = false as unknown as T, reverseValue?: U) {
    const [state, setState] = useState<T | U>(defaultValue);
    const actions = useMemo(() => {
        const reverseValueOrigin = (reverseValue === undefined ? !defaultValue : reverseValue) as U;
        const toggle = () => setState(value => (value === defaultValue ? reverseValueOrigin : defaultValue));
        return {
            toggle
        };
    }, []);
    return [state, actions];
}

export default useToggle;